import { render, staticRenderFns } from "./ImageMoving.vue?vue&type=template&id=37c20f16"
import script from "./ImageMoving.vue?vue&type=script&lang=js"
export * from "./ImageMoving.vue?vue&type=script&lang=js"
import style0 from "./ImageMoving.vue?vue&type=style&index=0&id=37c20f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports